<template>
    <mslPage :aIndex="4" :showMsg="true">
        <template v-slot:mslBody>
            <div class="contact">
                <!-- 期待你的加入 -->
                <div class="hope">
                    <div class="center m_center column_center hope_center">
                        <div class="join" v-if="baseInfo.contact_banner && baseInfo.contact_banner.id">{{ baseInfo.contact_banner.title }}</div>
                        <div class="welcome" v-if="baseInfo.contact_banner && baseInfo.contact_banner.id" v-html="baseInfo.contact_banner.content"></div>
                    </div>
                </div>
<!--                <img :src="require('../assets/logo.png')" alt="">-->
                <!-- 地图 -->
                <div class="map" v-if="companyInfo && companyInfo.length > 0">
                    <div class="center m_center map_center">
                        <div id="allmap" class="allmap"></div>
<!--                        <div class="allmap">-->
<!--                          <TdtMap :center="[113.280637, 23.125178]" :zoom="11" @click="mapClick"></TdtMap>-->
<!--                        </div>-->
                        <!--                        <img src="../assets/pc_pic/contant_us/contant_us.png" alt="">-->
                    </div>
                </div>
            </div>
        </template>
    </mslPage>
</template>


<script>
    // import BaiduMap from 'BaiduMap'
    import { map, baseInfo } from '../api/common.js'
    import myMap  from '../utils/BMap.js'
    import { TdtMap, initApiLoader } from "vue-tianditu";
    initApiLoader({
      v: "4.0",
      tk: "ac4574b214e137c925e5abfbd7bba5b8"
    });

    export default {
        name: "contact",
      components: { TdtMap },
        data() {
            return {
                logo_img: require('../assets/mapLogo.png'),
                baseInfo: {},
                companyInfo: [],
                activeIndex: 4,
                map: null
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.getMapInfo();
            })
            this.getBaseInfo();
        },
        methods: {

            getBaseInfo () {
                try {
                    baseInfo().then(res => {
                        if(res.code == 1) {
                            this.baseInfo = res.data;
                            console.log(this.baseInfo);
                        }
                    })
                } catch {
                    this.$message.error('获取数据失败，请刷新')
                }
            },
            getPointsCenter(lonlatarr) {
                var total = lonlatarr.length;
                var X = 0;
                var Y = 0;
                var Z = 0;
                lonlatarr.forEach(item => {
                    item.longitude = item.longitude || item.lng
                    item.latitude = item.latitude || item.lat
                    var lon = (item.longitude * Math.PI) / 180;
                    var latitude = (item.latitude * Math.PI) / 180;
                    var x, y, z;
                    x = Math.cos(latitude) * Math.cos(lon);
                    y = Math.cos(latitude) * Math.sin(lon);
                    z = Math.sin(latitude);
                    X += x;
                    Y += y;
                    Z += z;
                });

                X = X / total;
                Y = Y / total;
                Z = Z / total;

                var Lon = Math.atan2(Y, X);
                var Hyp = Math.sqrt(X * X + Y * Y);
                var Lat = Math.atan2(Z, Hyp);
                let lon = (Lon * 180) / Math.PI,
                    lat = (Lat * 180) / Math.PI;
                return {
                    lon,
                    lat,
                    str: `${lon},${lat}`
                };
            },

            getMapInfo() {
                try {
                    map().then(res => {
                        if (res.code == 1) {
                            this.companyInfo = res.data.shopList;
                            this.initMap();
                            // this.getMap();
                        }
                    })
                } catch {
                    this.$message.error('加载数据失败，请刷新');
                }
            },
            initMap() {
              myMap.initTDMap().then((TDMap) => {
                //初始化地图对象
                let map = new TMap("allmap");

                //允许鼠标滚轮缩放地图
                map.enableHandleMouseScroll();
                let arr = []
                let centerArr = []
                var markerInfoWin = new TInfoWindow();
                if (this.companyInfo && this.companyInfo.length > 0) {
                  this.companyInfo.forEach((item, index) => {
                    let _item = item;
                    // 经纬度计算
                    let idot = _item.position.indexOf(',');
                    let lat = Number(_item.position.substring(0, idot)); // 纬度
                    let lon = Number(_item.position.substring(idot + 1, _item.position.length)); // 经度
                    // all经纬度
                    centerArr.push({
                      longitude: lon,
                      latitude: lat
                    })
                    // 各个地点
                    var icon = new TIcon("https://sumfen-oss.oss-cn-shenzhen.aliyuncs.com/msl/images/point.png",new TSize(30,35),{anchor:new TPixel(9,27)});
                    var marker = new TMarker(new TLngLat(lon, lat),{icon:icon});

                    arr.push(marker)
                    // 将标注添加到地图中
                    arr.forEach(citem => {
                      map.addOverLay(citem)
                      TEvent.addListener(citem, 'click', function (e) {
                        // 弹窗模版
                        const sContent = '<div class="info_box">\n' +
                            '    <div class="i_title" style="font-size: 16px; color: #4D4D4D; font-weight: 600;" v-if="_item.company">'+ item.company +'</div>\n' +
                            '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.contacts">联系人： ' + item.contacts + '</div>\n' +
                            '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.gcontact_number">联系方式： ' + item.contact_number + '</div>\n' +
                            '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.fax">传真： ' + item.fax + '</div>\n' +
                            '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.address">店铺地址： ' + item.address + '</div>\n' +
                            '</div>';

                        // 相对于点偏移的位置
                        markerInfoWin.setLabel(sContent);
                        markerInfoWin.setWidth(300);
                        markerInfoWin.setHeight(100);
                        markerInfoWin.setLngLat(citem.getLngLat());
                        map.addOverLay(markerInfoWin);
                      });
                    })

                  })
                }
                // // 所有点中心
                let center = this.getPointsCenter(centerArr)
                //设置显示地图的中心点和级别
                map.centerAndZoom(new TLngLat(center.lon, center.lat),5);

                return;
              })
            },

            getMap() {
                myMap.initBMap().then((BaiduMap) => {
                    // 百度地图API功能
                    // var map = new BaiduMap.Map("allmap");    // 创建Map实例
                    // map.centerAndZoom(new BaiduMap.Point(116.404, 39.915), 11);  // 初
                    let map = new BaiduMap.Map('allmap'); // 创建地图实例
                    map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
                    map.setMapType(BMAP_SATELLITE_MAP);      // 设置地图类型为普通卫星地图模式
                    let arr = []
                    let centerArr = []
                    let infoArr = []
                    console.log(this.companyInfo, 'companyInfo');
                    if (this.companyInfo && this.companyInfo.length > 0) {
                        this.companyInfo.forEach((item, index) => {
                            let _item = item;
                            // 经纬度计算
                            let idot = _item.position.indexOf(',');
                            let lat = Number(_item.position.substring(0, idot)); // 纬度
                            let lon = Number(_item.position.substring(idot + 1, _item.position.length)); // 经度
                            // all经纬度
                            centerArr.push({
                                longitude: lon,
                                latitude: lat
                            })

                            // let logo_img = require('../assets/pc_pic/logo.png') ;

                            // 各个地点
                            // let myIcon = new BaiduMap.Icon(this.logo_img, new BaiduMap.Size(200, 72));
                            let myPoint = new BaiduMap.Point(lon, lat)
                            let markerTemp = new BaiduMap.Marker(myPoint)
                            arr.push(markerTemp)
                            // 将标注添加到地图中
                            arr.forEach(item => {
                                map.addOverlay(item)
                            })
                            let html = '<div class="info_box">\n' +
                                '    <div class="i_title" style="font-size: 16px; color: #4D4D4D; font-weight: 600;" v-if="_item.company">'+ _item.company +'</div>\n' +
                                '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.contacts">联系人： ' + _item.contacts + '</div>\n' +
                                '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.gcontact_number">联系方式： ' + _item.contact_number + '</div>\n' +
                                '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.fax">传真： ' + _item.fax + '</div>\n' +
                                '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.address">店铺地址： ' + _item.address + '</div>\n' +
                                '</div>';
                            // 信息窗
                            let opts = {
                                boxStyle:{
                                    width: "270px"
                                }
                            }
                            let infoWindow = new BaiduMap.InfoWindow(html, opts);  // 创建信息窗口对象
                            markerTemp.addEventListener("click", function () {
                                map.openInfoWindow(infoWindow, myPoint); //开启信息窗口
                            });
                        })
                    }

                    // // 所有点中心
                    let center = this.getPointsCenter(centerArr)
                    // 创建中心点坐标
                    let point = new BaiduMap.Point(center.lon, center.lat);

                    console.log(point, 'point');
                    // 初始化地图，设置中心点坐标和地图级别
                    map.centerAndZoom(point, 5)
                });
            }
        }
    }
</script>


<style scoped lang="scss">
::v-deep .tdt-control-container {
  display: none !important;
}
    .contact {
        /* banner */
        .hope {
            .hope_center {
                padding: 80px 0;

                .join {
                    font-size: 30px;
                    font-weight: bold;
                    line-height: 38px;
                    color: #262626;
                }

                .welcome {
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 28px;
                    color: #262626;
                    opacity: 0.6;
                    margin-top: 12px;
                    &::v-deep {
                        p {
                            margin-top: 0!important;
                            margin-bottom: 0!important;
                        }
                    }
                }
            }
        }

        /* 地图 */
        .map {
            width: 100%;
            padding-bottom: 80px;

            .map_center {
                .allmap {
                    width: 100%;
                    height: 586px;
                }

                /*img {*/
                /*    width: 100%;*/
                /*    height: 586px;*/
                /*}*/
            }
        }
    }
</style>
